import developmentSettings from '../../../../settings.dev.json'
import productionSettings from '../../../../settings.prod.json'

export const isProduction = () => process.env.TARGET_ENV === 'production'

export const isDevelopment = () => process.env.TARGET_ENV !== 'production'

class SettingsHelper {
  static setting = isProduction()
    ? productionSettings
    : developmentSettings
}

export default SettingsHelper.setting
